import React, { useContext } from "react";
import { IoFilterSharp } from "react-icons/io5";
import FilterLabel from "../../components/Label/FilterLabel";
import HomeFilterForm from "../../components/Forms/HomeFilterForm";
import CommonContext from "../../hooks/CommonContext";

const JobFilter = () => {
  const { gettingResponse, applyFilterResponse } = useContext(CommonContext);

  return (

    <>
      <div className="d-flex justify-content-between align-items-center">
        {
          gettingResponse === false && applyFilterResponse === false ?
            <>
              <div className="form-label fs-4 mb-0 job-filter-heading w-50 py-3 placeholder rounded-2"></div>
              <div className="w-50 text-end">
                <div className="col-4 py-3 placeholder rounded-2"></div>
              </div>
            </>
            :
            <>
              <FilterLabel spanContent={"Filter"} labelHtmlFor={"skills"} lableClassName={"form-label fs-4 mb-0 job-filter-heading"} />
              <IoFilterSharp className="fs-5" />
            </>
        }
      </div>
      <hr className="mb-3 mt-1" />

      <HomeFilterForm />
    </>
  );
};

export default JobFilter;
